exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-field-wrapper{position:relative}.input-suggestions{position:absolute;top:calc(100% - 10px);left:0;width:95%;background-color:#fff;box-shadow:0 2px 5px rgba(0,0,0,.2);z-index:1000;font-size:14px;border-radius:2px}.input-suggestions-header{font-weight:bold;color:#d32f2f;padding:5px 10px;cursor:default}.input-suggestions-list{display:flex;flex-direction:column}.input-suggestion-data{padding:8px 10px;color:#333;cursor:default}.no-suggestions{padding:5px 10px;color:#777;font-style:italic}", ""]);

// exports
